export enum Size {
  PX_0 = 0,
  PX_2 = 0.5,
  PX_4 = 1,
  PX_6 = 1.5,
  PX_8 = 2,
  PX_10 = 2.5,
  PX_12 = 3,
  PX_14 = 3.5,
  PX_16 = 4,
  PX_18 = 4.5,
  PX_20 = 5,
  PX_24 = 6,
  PX_28 = 7,
  PX_32 = 8,
  PX_36 = 9,
  PX_40 = 10,
  PX_44 = 11,
  PX_48 = 12,
  PX_56 = 14,
  PX_64 = 16,
  PX_72 = 18,
  PX_80 = 20,
  PX_96 = 24,
  PX_112 = 28,
  PX_128 = 32,
  PX_144 = 36,
  PX_160 = 40,
  PX_176 = 44,
  PX_192 = 48,
  PX_208 = 52,
  PX_224 = 56,
  PX_240 = 60,
  PX_256 = 64,
  PX_288 = 72,
  PX_320 = 80,
  PX_352 = 88,
  PX_362 = 90,
  PX_384 = 96,
  PX_480 = 120,
  PX_512 = 128,
  PX_576 = 144,
  PX_640 = 160,
  PX_704 = 176,
  PX_768 = 192,
  PX_800 = 200,
  PX_1000 = 250,
  PX_1200 = 300,
  PX_1400 = 350,
  PX_1448 = 362,
  PX_1600 = 400,
  PX_1648 = 412,
  PX_1800 = 450,
  PX_1900 = 475,
  PX_2000 = 500,
  PX_2144 = 536,
  PX_2400 = 600,
  PX_3200 = 800,
  PX_3600 = 900,
  PX_4096 = 1024,
}
